import React from "react";
import withSvgIcon from "~/hocs/with-svg-icon";

export const PortalIcon = withSvgIcon(
    <g>
        <path d="M47.4,0c-16.43,0-29.79,13.37-29.79,29.79s13.37,29.79,29.79,29.79,29.79-13.37,29.79-29.79S63.83,0,47.4,0ZM75.17,28.78h-11.13c-.21-11.36-4-21.14-9.41-25.82,11.52,3.11,20.09,13.44,20.54,25.82ZM46.4,2.07v26.71h-13.64c.27-14.22,6.2-25.75,13.64-26.71ZM46.4,30.78v26.74c-7.44-.96-13.37-12.5-13.64-26.74h13.64ZM48.4,57.52v-26.74h13.64c-.26,14.24-6.2,25.78-13.64,26.74ZM48.4,28.78V2.07c7.44.96,13.37,12.48,13.64,26.71h-13.64ZM40.17,2.96c-5.41,4.69-9.19,14.46-9.4,25.82h-11.13c.45-12.38,9.02-22.71,20.54-25.82ZM19.63,30.78h11.13c.21,11.38,3.99,21.16,9.41,25.85-11.53-3.11-20.1-13.46-20.54-25.85ZM54.63,56.63c5.41-4.69,9.2-14.47,9.41-25.85h11.13c-.43,12.39-9.01,22.74-20.54,25.85Z" />
    </g>,
    "7 0 80 60"
);
